import React, { useEffect,useState } from "react";
import Rightside from "../Aviator/Rightside";
import Leftside from "../Aviator/Leftside";
import Bettingbutton from "../Aviator/Bettingbutton";
import Header from "../Aviator/Header";
import Result from "../pages/Result";
import { useNavigate } from "react-router-dom";
const HomePage = () => {
  const [profileData, setProfileData] = useState(0);
  const [resultData, setResultData] = useState(0);
  const [ActiveUserData, setActiveUserData] = useState(null);
  const [Activemultiplier, SetActivemultiplier] = useState(null);
  const [roundStatusDummyActive, setroundStatusDummyActive] = useState(null);
   const navigate = useNavigate();
      const gettoken = localStorage.getItem('token');
      const role = localStorage.getItem('role');
      const getId = localStorage.getItem('_id');
  
   useEffect(()=>{
      if(!gettoken && !getId && !role){
          navigate("/");
          localStorage.clear();
      }
      else{
          navigate("/home");
       
      }
   },[])
  return (
    <div>
      <Header profileData={profileData} />
      <div className="aviator_all">
        <div className="sideAvi d-flex gap-2">
          <Leftside ActiveUserData={ActiveUserData} Activemultiplier = {Activemultiplier} roundStatusDummyActive={roundStatusDummyActive}/>
          <div className="w-100 home">
            <Result resultData={resultData} />
            <Rightside resultData={resultData} />
            <Bettingbutton
              setProfileData={setProfileData}
              setResultData={setResultData}
              setActiveUserData={setActiveUserData}
              SetActivemultiplier={SetActivemultiplier}
              setroundStatusDummyActive={setroundStatusDummyActive}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
